import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    fuel: [],
    loading: false,
    error: null,
  };
const fuelSlice = createSlice({
    name: "fuel",
    initialState,
    reducers: {
        fuelRequest(state) {
        state.loading = true;
        state.error = null;
      },
      fuelSuccess(state, action) {
        state.loading = false;
        state.fuel = action.payload;
      },
      fuelAddSuccess(state, action) {
        state.loading = false;
        state.fuel.push(action.payload);
      },
      fuelEditSuccess(state, action) {
        state.loading = false;
        state.fuel = state.fuel.map((fuel: { id: any; }) =>
          fuel.id === action.payload.id ? action.payload : fuel
        );
      },
      fuelDeleteSuccess(state, action) {
        state.loading = false;
        state.fuel = state.fuel.filter((fuel: { id: any; }) => fuel.id !== action.payload);
      },
      fuelError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      getFuelByIdRequest(state) {
        state.loading = true;
        state.error = null;
      },
      getFuelByIdSuccess(state, action) {
        state.loading = false;
        state.user = action.payload;  // Store the user fetched by ID in `user`
      },
      getFuelByIdError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });

  export const {
      fuelRequest,
      fuelSuccess,
      fuelAddSuccess,
      fuelEditSuccess,
      fuelDeleteSuccess,
      fuelError,
      getFuelByIdRequest,
      getFuelByIdSuccess,
      getFuelByIdError
  } = fuelSlice.actions;

export default fuelSlice.reducer;
  